import React from 'react';

interface Result {
  result: {
    action?: string;
    adCreativeID: number;
    advertiserID: number;
    brandName: string;
    bulletedDescription: string[];
    clickUrl: string;
    displayUrl: string;
    logoUrl: string;
    paragraphDescription?: string;
    position: number;
    publisherRevenue: number;
    title: string;
  };
}

const TransparentlyResult: React.FC<Result> = ({ result }) => {
  return (
    <div className="transparently-result bz3-cta border bz3-cta__center center" data-href={result.clickUrl}>
      <div className="bz3-cta-inner bz3-cta-inner__center">
        <div className="bz3-lead-title">
          <h4 className="compact oversized-font">{result.title}</h4>
        </div>

        <div className="bz3-cta-image bz3-cta-image__center padding border-bottom">
          <div className="bz3-cta-image-wrapper">
            <img alt="" src={result?.logoUrl} />

            <div className="button">{result.action}</div>
          </div>
        </div>

        <div className="bz3-cta-description bz3-cta-description__center padding border-bottom">
          <h4 className="compact oversized-font">{result.title}</h4>

          <div className="bz3-cta-text compact">
            {result.bulletedDescription && (
              <ul>
                {result.bulletedDescription.map((description: string, i: number) => {
                  const key = `bd-${i}`;
                  return description ? <li key={key}>{description}</li> : '';
                })}
              </ul>
            )}
            {result.paragraphDescription && <p>{result.paragraphDescription}</p>}
            <div className="result-url">{result.displayUrl}</div>
          </div>
        </div>

        <div className="bz3-cta-link bz3-cta-link__center padding">
          <div className="button">{result.action}</div>
        </div>
      </div>
    </div>
  );
};

export default TransparentlyResult;
